import {callApi} from "./rest.js";

const ROOT_URL = '/api/diseases';

export const getDiseaseList = async (current_page) => {
    const url = `${ROOT_URL}?page_size=1000&page=${current_page}`;
    return await callApi(url, "GET");
};